// src/pages/LoginPage.jsx
import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom"; // ✅ Replace hooks with withRouter
import "./LoginPage.css";
import { auth, forceLogout } from "../../../services/oidc/authConfig";
import { envVariables } from "../../../config/appConfig";
import LOGO from "../../../img/logo.svg";

const RH_HORIZONTAL_LOGO = `${process.env.PUBLIC_URL}/img/rh_horizontal_ic.svg`;
const isNigeria = (envVariables.COUNTRY_LOCALE || "").split("-")[1] === "NG";

function LoginPage() {
  const [error, setError] = useState(null);
  const hasStartedLogin = useRef(false);

  useEffect(() => {
    const reason = new URLSearchParams(window.location.search).get("reason");
    if (reason === "callback_failed") {
      forceLogout(reason);
      return;
    }

    if (
      auth.isAuthenticated() &&
      localStorage.getItem("isAuthenticated") === "true"
    ) {
      window.location.href =
        sessionStorage.getItem("post_login_redirect") || "/";
      return;
    }

    if (hasStartedLogin.current) return;
    hasStartedLogin.current = true;

    auth.initiateLogin().catch((err) => {
      setError(err?.message || String(err));
    });
  }, []);

  if (error) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="error-message">{error}</div>
        </div>
      </div>
    );
  }

  // Redirecting to Keycloak — show the logo as a loading indicator.
  return (
    <div className="login-loader">
      <img
        src={isNigeria ? LOGO : RH_HORIZONTAL_LOGO}
        alt="Reliance HMO's Logo"
        className="login-loader-logo"
      />
    </div>
  );
}

// ✅ Wrap export with withRouter for React Router v4.3
export default withRouter(LoginPage);
